<template>
    <div class="freight">
      <div class="typeArea">
        <!-- 精选运价 -->
        <div class="xcsj_bt">
          <Animation :message="jx_parentMessage" />
          <div class="xc_right">
              <el-button type="primary" round @click="chakangengduo">
                  查询更多
                  <img src="../../assets/Frame(2).png" />
              </el-button>
          </div>
        </div>
        <div class="chakan">
            <div class="pagebiaoti">
              <div class="zxyj"></div>
              <div class="cwh">舱位号</div>
              <div class="qyg">起运港</div>
              <div class="mdg">目的港</div>
              <div class="xx">箱型价格</div>
              <div>发布时间</div>
              <div class="fqcwqr"></div>
            </div>
            <div class="line"></div>
            <vue-seamless-scroll :data="jxyjList" class="warp" :class-option="classOption">
                <div v-for="(item,index) in jxyjList" :key="index" class="father" >
                  <div @click="tiaozhuan(item)" class="detail">
                    <img class="zxyj zxyjImg" src="../../assets/images/hpcopy/zxyj.png" alt="">
                    <div class="cwh">{{item.order_sn}} </div>
                    <el-tooltip :content="item.pol_name" placement="bottom-start">
                       <div class="qyg">{{item.pol_name}}</div>
                    </el-tooltip>
                    <el-tooltip :content="item.pod_name" placement="bottom-start">
                       <div class="mdg">{{item.pod_name}}</div>
                    </el-tooltip>
                    <!-- <div class="qyg">{{item.pol_name}}</div>
                    <div class="mdg">{{item.pod_name}} </div> -->
                    <div class="xx jiacu">
                      <div class="boxdetail" v-for="(it,idx) in item.basic_freight" :key="idx">
                        <div class="bianju">{{it.box_type}}<span class="price">${{it.price}}</span></div>
                      </div>
                    </div>
                    <div class="detail_son">{{item.online_time}} </div>
                  </div>
                  <div class="fqcwqr">
                    <el-button @click="faqi(item)">详情</el-button>
                  </div>
                </div>
              </vue-seamless-scroll>
              <!-- 详情 -->
              <el-dialog width="45%" title="舱位详情" :visible.sync="dialogVisible" 
              @close-on-press-escape="quxiao"
              @close-on-click-modal="quxiao"
              @close="quxiao">
                <div class="dialogForm">
                  <div class="shang">
                    <div class="logo">
                      <img :src="dialogForm.shipping_companyLogo" alt="" />
                    </div>
                    <div class="qiyun">
                      <div class="date"><span class="jiacu">ETD:</span>{{ dialogForm.etd }}</div>
                      <div class="address">{{ dialogForm.pol_name }}</div>
                    </div>
                    <div class="dao">
                      <div class="tian">{{ dialogForm.shipping_date }}天</div>
                      <img src="@/assets/images/Group 113@2x.png" alt="" />
                      <div class="zhida">
                        {{ dialogForm.is_transit == 1 ? "中转" : "直达" }}
                      </div>
                    </div>
                    <div class="qiyun">
                      <div class="date"><span class="jiacu">ETA:</span>{{ dialogForm.eta }}</div>
                      <div class="address">{{ dialogForm.pod_name }}</div>
                    </div>
                  </div>
                  <div class="xia">
                    <div class="kuan">供应商编号：{{dialogForm.supplier_infoSn}}</div>
                    <div class="kuan">舱位号：{{dialogForm.order_sn}}</div>
                    <div class="kuan">航线：{{ dialogForm.routeCd }}</div>
                    <div class="kuan">船名航次：{{dialogForm.vessel}}/{{dialogForm.voyage}}</div>
                    <div class="kuan">运输条款：{{ dialogForm.transportation_terms }}</div>
                    <div class="kuan">箱源：{{ dialogForm.box_source }}</div>
                    <div class="kuan">
                      提单类型：{{ dialogForm.bill_of_lading_type_desc }}
                    </div>
                    <div class="kuan">目的港免堆/免用箱：{{ dialogForm.freetime_desc }}</div>
                    <div class="kuan">截单时间：{{ dialogForm.cutoff_bill_of_lading_time }}</div>
                    <div class="kuan">进港/开港时间：{{ dialogForm.cyOpen }}</div>
                    <div class="kuan">截港时间：{{ dialogForm.cutoff_enter_the_port_time }}</div>
                    <div class="kuan">
                      运价有效期：{{ dialogForm.freight_rate_state_time }} -
                      {{ dialogForm.freight_rate_end_time }}
                    </div>
                    <div class="kuan">
                      品名要求：
                      <el-popover placement="bottom" width="200" trigger="click">
                        <p v-for="(it,idx) in dialogForm.product_name" :key="idx">
                          {{ it }}
                        </p>
                        <div class="cilick" slot="reference">点击查看</div>
                      </el-popover>
                    </div>
                  </div>
                  <!-- 箱型 -->
                  <el-table :data="dialogForm.basic_freight">
                    <el-table-column property="box_type" label="箱型" width="75"></el-table-column>
                    <el-table-column property="price" label="价格(USD)"></el-table-column>
                    <el-table-column property="dead_freight" label="亏舱费(CNY)"></el-table-column>
                    <el-table-column property="overweight" label="限重">
                      <template slot-scope="scope">
                          {{scope.row.overweight==0?'不限重':'限重'}}
                      </template>
                    </el-table-column>
                    <el-table-column  width="380" property="weight_limit" label="限重规则">
                        <template slot-scope="scope">
                            <div v-if="scope.row.weight_limit==''">--</div>
                            <div v-else>
                              <el-table
                              border
                              style="width: 500px"
                                :data="scope.row.weight_limit">
                                <el-table-column  width="130" property="min_weight" label="最小重量（kgs）">
                                    <template slot-scope="scopeItem">
                                        {{scopeItem.row.min_weight!=''?scopeItem.row.min_weight:'--'}}
                                    </template>
                                </el-table-column>
                                <el-table-column  width="130" property="max_weight" label="最大重量（kgs）">
                                    <template slot-scope="scopeItem">
                                        {{scopeItem.row.min_weight!=''?scopeItem.row.max_weight:'--'}}
                                    </template>
                                </el-table-column>
                                <el-table-column property="overweight_fees" label="超重费用">
                                    <template slot-scope="scopeItem">
                                      USD {{scopeItem.row.min_weight!=''?scopeItem.row.overweight_fees:'--'}}
                                    </template>
                                </el-table-column>
                              </el-table>
                            </div>
                        </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="dialogFormVisible = true">舱位确认</el-button>
                </div> -->
              </el-dialog>
              <!-- 选择想要确定的舱位数量 -->
              <el-dialog width="35%" title="舱位确认" :visible.sync="dialogFormVisible" 
              top="30vh"
              @close-on-press-escape="quxiao"
              @close-on-click-modal="quxiao"
              @close="quxiao">
                <div class="dialogBox">
                  <div v-for="(item,index) in dialogBox.boxtype" :key="index">
                    <div>{{item.box_type}}</div>
                    <el-input-number v-model="item.number" :min="0" :max="100" label="描述文字"></el-input-number>
                  </div>
                </div>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="quxiao">取 消</el-button>
                  <el-button type="primary" @click="tijiaoFaqi">发 起</el-button>
                </div>
              </el-dialog>
        </div>
      </div>
    </div>
</template>

<script>
import Animation from './AnimationPage.vue';
import { homeCherryPickList,askAboutShippingSpace } from "@/api/api";
// import vueSeamlessScroll from "vue-seamless-scroll";
export default {
    components:{
        // vueSeamlessScroll,
        Animation,
    },
    data(){
        return{
            jxyjList:[],
            // 标题
            jx_parentMessage:{
                title:'精选运价',
                content:'多口岸各航线庄家发布最新运价'
            },
            jxyjNewList:[],
            classOption: {
              singleHeight: 94,   // 偏移量  单位px
              limitMoveNum:8,  // 最少几条数据可以滚动
              waitTime:2000,  // 滚动完  展示数据展示多长时间
              // step:0,  // 当前滚动速度  默认1(最小速度)
            },
            // 要确定的舱位箱型数量
            dialogFormVisible:false,
            dialogBox:{
              shipping_space_id:'',
              boxtype:[]
            },
            dialogForm:{},
            dialogVisible:false,
            headers:{
                token: localStorage.getItem('token')
            },
        }
    },
    methods:{
      quxiao(){
        this.dialogFormVisible = false
        this.classOption.limitMoveNum = 8
      },
        faqi(e){
          if(localStorage.getItem('userInfo')){
            let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
            let is_vip=JSON.parse(localStorage.getItem('userInfo')).is_vip
            if(is_authentication!=2){
                  if(is_authentication==0){
                    this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                      this.$router.push({
                        name:'UserInfo',
                        params:{
                          menuInx: '2'
                        }
                      })
                    }).catch(() => {
                      this.$message({
                        type: 'info',
                        message: '已取消'
                      });          
                    });
                  }else{
                    this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                      this.$router.push({
                        name:'UserInfo',
                        params:{
                          menuInx: '2'
                        }
                      })
                    }).catch(() => {
                      this.$message({
                        type: 'info',
                        message: '已取消'
                      });          
                    });
                  }
                  
                  return
              }

              if(is_vip==0){
                this.$message({
                  type:'error',
                  message:'您还不是会员，请先购买会员'
                })
                return
              }

          }else{
            this.$message({
                type:'error',
                message:'您还未登录/注册，请先进行登录/注册'
              })
              return
          }
          this.dialogVisible = true
          this.dialogBox.shipping_space_id = e.shipping_space_id
          this.dialogBox.boxtype = e.basic_freight
          this.dialogForm = e
          this.dialogForm.shipping_companyLogo = e.shipping_company.logo
          this.dialogForm.supplier_infoSn = e.shipping_company.sn
          

          for (let i = 0; i < this.dialogBox.boxtype.length; i++) {
            this.dialogBox.boxtype[i].number=0
          }

          this.classOption.limitMoveNum = this.jxyjList.length+10
        },
        async tijiaoFaqi(){
          try {
            const res = await askAboutShippingSpace(this.dialogBox,this.headers)
            
            if( res.code == 1 ) {
              this.dialogFormVisible = false
              this.classOption.limitMoveNum = 8
              this.$message({
                type:'success',
                message:'发起成功'
              })
            }else{
              this.$message({
                type:'error',
                message:res.msg
              })
            }
          } catch (error) {
            console.log(error,'失败');
          }
        },
        // 获取列表
        async getList(){
          const res = await homeCherryPickList();
          if (res.code == 1) {
            this.jxyjList = [...res.data];
          }

          this.jxyjNewList = this.jxyjList.reduce((acc, item, index) => {
            if (index % 2 === 0) acc.push([item]); // 开始新组
            else acc[acc.length - 1].push(item); // 添加到当前组
            return acc;
          }, []);

        },
        chakangengduo(){
          this.$router.push('/SelectedFreightRates')
          sessionStorage.setItem('lineIndex',1)
        },
        tiaozhuan(e){
          if(localStorage.getItem('userInfo')){
            let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
            let is_vip=JSON.parse(localStorage.getItem('userInfo')).is_vip
            if(is_authentication!=2){
                  if(is_authentication==0){
                    this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                      this.$router.push({
                        name:'UserInfo',
                        params:{
                          menuInx: '2'
                        }
                      })
                    }).catch(() => {
                      this.$message({
                        type: 'info',
                        message: '已取消'
                      });          
                    });
                  }else{
                    this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
                      this.$router.push({
                        name:'UserInfo',
                        params:{
                          menuInx: '2'
                        }
                      })
                    }).catch(() => {
                      this.$message({
                        type: 'info',
                        message: '已取消'
                      });          
                    });
                  }
                  
                  return
              }

              if(is_vip==0){
                this.$message({
                  type:'error',
                  message:'您还不是会员，请先购买会员'
                })
                return
              }
          }else{
            this.$message({
                type:'error',
                message:'您还未登录/注册，请先进行登录/注册'
              })
              return
          }
            
          sessionStorage.setItem('parameter',JSON.stringify(e))
          this.$router.push({
            name:'BookingSpace',
            params:e
          })
        }

    },
    mounted(){
        this.getList()
    },
    beforeDestroy() {

    },
}
</script>

<style lang="scss" scoped>
.freight{
    width: 100%;
    padding-bottom: 175px;
    padding-top: 5.625rem;
  }

  // 版心
.typeArea{
    width: 110.875rem;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}

.pagebiaoti{
  margin-top: 38px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 20px;
  color: #0E2D55;
}

.line{
  margin-top: 21px;
  width: 1764px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #E9EBEE;
}

.zxyj{
  width: 116px;
  margin-right: 35px;
  // margin-left: 10px;
  .zxyjImg{
    width: 113px;
    height: 44px;
  }
}

.cwh{
  width: 84px;
  margin-right: 50px;
}

.qyg{
  width: 220px;
  margin-right: 44px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}

.mdg{
  width: 304px;
  margin-right: 48px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}

.jiacu{
  font-weight: 600;
}

.xx{
  width: 490px;
  margin-right: 65px;
  display: flex;
  align-items: center;

  .bianju{
    font-weight: 500;
    font-size: 20px;
    color: #0A1D36;
    width: 128px;
    padding-right: 40px;
  }

  .price{
    color: #E03F3F;
    margin-left: 8px;
  }
}

.fqcwqr{
  margin-left: 60px;
  .el-button{
    width: 96px;
    height: 38px;
    background: rgba(42, 134, 255, 0.12);
    border: 0;
    padding: 0;
    text-align: center;
    color: #064FAF;
    font-size: 16px;
  }

  .el-button:hover{
    background: #064FAF;
    color: #FFFFFF;
  }
}

.gengduo{
  display: flex;
  align-items: center;
  justify-content: center;
  .el-button{
    background: #064FAF;
    color: #fff;
    border: 0rem;
  }
}

.detail{
  cursor: pointer;
  line-height: 93PX;
}
.father{
  border-bottom: 1px solid #E9EBEE;
}

.father,.detail,.box{
  display: flex;
  align-items: center;
}

.fat{
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
}

.warp {
  height: 658PX;
  // width: 22.5rem;
  // margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
}

.xcsj_bt{
  margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: #999999;
    line-height: 28px;
    font-style: normal;
    text-transform: none;
    .xc_left{
        font-size: 32px;
        color: #000000;
        line-height: 38px;
    }
}
.xc_right .el-button{
    width: 120px;
    height: 48px;
    background: #064FAF;
    border-radius: 26px 26px 26px 26px;
    img{
      width: 16px;
      height: 16px;
    }
}

.dialogBox{
  display: flex;
  justify-content: space-around;
}

.dialogForm{
  .shang {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 84px;
    border-bottom: #eee solid 1px;
    .logo {
      width: 48px;
      // height: 48px;
      margin-right: 40px;
      img{
        width: 65px;

      }
    }
    .qiyun {
      // width: 120px;
      .date {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 19px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        margin-bottom: 4px;
      }
      .address {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #333333;
        line-height: 28px;
        font-style: normal;
        text-transform: none;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .dao {
      width: 100px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #999999;
      font-style: normal;
      text-transform: none;

      margin: 0 24px;
      img {
        width: 100px;
        height: 7px;
      }
      div {
        height: 12px;
      }
    }
  }

  .xia{
    margin-top: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .kuan{
      margin-right: 24px;
      margin-bottom: 8px;
      display: flex;
    }

    .cilick{
      cursor: pointer;
      color: #0073f5;
    }
  }
}
</style>